// Taşeron portalı — uygulama başlığı (S37-1, Carbon 2a koyu 48px kabuk). Sol: marka +
// firma switcher'ı (aktif firma adı, çoklu firmada menü + dikkat rozeti — design review S1,
// seçenek H-A; "Taşeron Portalı" etiketi düştü). Sağ: hesap menüsü (dil radyo grubu dahil).
// Arama / bildirim / saha switcher'ı sözleşmede SUPPLIER rolü için karşılıksız → yok.

import { Logo } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { CompanySwitcher } from './CompanySwitcher';
import { UserMenu } from './UserMenu';

export function AppHeader() {
  const { t } = useTranslation();
  return (
    <header className="flex h-12 items-stretch justify-between border-b border-shell-border bg-shell text-shell-fg">
      <div className="flex min-w-0 items-center gap-2.5 px-3">
        <Logo className="h-9 shrink-0 text-shell-fg" title={t('app.name')} />
        <span className="hidden text-shell-fg-muted sm:inline" aria-hidden="true">
          ·
        </span>
        <CompanySwitcher />
      </div>
      <div className="flex items-stretch">
        <UserMenu />
      </div>
    </header>
  );
}
